<template>
  <div>
    <div style="width: calc(100% - 40px);margin: 20px 20px">
      <el-table :data="tableData" border highlight-current-row height="450px">
        <el-table-column
          type="index"
          label="序号"
          width="70"
          align="center">
        </el-table-column>
        <el-table-column
          label="操作类型"
          min-width="120"
          align="center">
          <template slot-scope="scope">
            <span>{{getEventTypeDesc(scope.row.event_type)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="event_time"
          label="操作时间"
          min-width="120"
          align="center">
        </el-table-column>
        <el-table-column
          prop="event_remarks"
          label="相关信息"
          min-width="120"
          align="center">
        </el-table-column>
        <el-table-column
          prop="esp_name"
          label="操作人员"
          min-width="120"
          align="center">
        </el-table-column>
      </el-table>
    </div>
<!--    <div style="margin-top: 10px;height: 40px;text-align: center">-->
<!--      <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"-->
<!--                     :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"-->
<!--                     layout="total, sizes, prev, pager, next, jumper">-->
<!--      </el-pagination>-->
<!--    </div>-->
    <div style="height: 50px">
      <el-row style="margin: 0 20px">
        <div class="cancel-btn" style="float: right" @click="closeDetail()">
          <span>关闭</span>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import {accomodationgetevents} from '../../../api/yanglaoyuan/homebed'

export default {
  name: 'checkInDetail',
  model: {
    prop: 'detailShow',
    event: 'change'
  },
  props: {
    homeBedPersonObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      // pageSize: 10,
      // currentPage: 1,
      // totalCells: 0,

      tableData: []
    }
  },
  created () {
    this.getEventsData()
  },
  methods: {
    closeDetail () {
      this.$emit('change', false)
    },
    // handleSizeChange (val) {
    //   this.pageSize = val
    //   this.getEventsData()
    // },
    // handleCurrentChange (val) {
    //   this.currentPage = val
    //   this.getEventsData()
    // },

    // table显示
    getEventTypeDesc (eventType) {
      let result = '未知'
      if (eventType === 0) {
        result = '办理入住'
      } else if (eventType === 1) {
        result = '修改入住信息'
      } else if (eventType === 2) {
        result = '申请退住'
      } else if (eventType === 3) {
        result = '退住办结'
      } else if (eventType === 4) {
        result = '外出请假'
      } else if (eventType === 5) {
        result = '更换床位'
      } else if (eventType === 6) {
        result = '取消请假'
      } else if (eventType === 7) {
        result = '取消申请退住'
      } else if (eventType === 8) {
        result = '设置护理项目'
      }
      return result
    },

    // 访问接口
    getEventsData () {
      this.tableData = []
      let params = {
        // page: this.currentPage,
        // size: this.pageSize
      }
      let data = {
        id: this.homeBedPersonObj.row.id,
        eid: this.homeBedPersonObj.row.eid
      }
      accomodationgetevents(params, data).then(res => {
        this.tableData = res.data.arrdata
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/checkInDetail.vue